import { useEffect, useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAppStore } from "../store/app";
import { syncBackButton } from "../lib/telegram";

const TAB_ROOTS = ["/", "/browse", "/collections", "/profile"];

/**
 * Drive the native Telegram BackButton from router + overlay state. An open sheet
 * is "back" first (Back closes it); otherwise Back shows on non-root routes and
 * pops history. Avoids the double-back bug with Telegram's own gesture.
 */
export function useBackButton(): void {
  const navigate = useNavigate();
  const location = useLocation();
  const switcherOpen = useAppStore((s) => s.channelSwitcherOpen);
  const adminOpen = useAppStore((s) => s.adminHubOpen);
  const setSwitcherOpen = useAppStore((s) => s.setChannelSwitcherOpen);
  const setAdminOpen = useAppStore((s) => s.setAdminHubOpen);

  const roots = useMemo(() => new Set(TAB_ROOTS), []);
  const sheetOpen = switcherOpen || adminOpen;
  const canGoBack = sheetOpen || !roots.has(location.pathname);

  useEffect(() => {
    const onBack = () => {
      if (adminOpen) return setAdminOpen(false);
      if (switcherOpen) return setSwitcherOpen(false);
      navigate(-1);
    };
    return syncBackButton(canGoBack, onBack);
  }, [canGoBack, adminOpen, switcherOpen, location.pathname, navigate, setAdminOpen, setSwitcherOpen]);
}
